import React from "react";
import { Grid, Box } from "@mui/material";
import "./mapData.scss";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/processor/actions";
import { connect } from "react-redux";
import "react-multi-carousel/lib/styles.css";
import ProgressBar from "../../../components/ProgressBar";
import MapDataTable from "../../../components/MapDataTable/TemplateDriven/MapDataTable";
import CNCTableWrapper from "../../../components/MapDataTable/Free-Form/CNCTableWrapper";
import ImageViewer from "./ImageViewer";
import ModalProcessor from "../../../components/Modal/rejectModal/ModalProcessor";
import TableSkeleton from "../../../components/TableSkeleton";

class DataEntryConatainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coorData: [],
      selectedFile: {
        tagName: "",
        fileNo: 0, // index is considered as file
        pageNo: 0,
      },
    };
  }

  handleCloseModal = () => {
    this.setState({
      openRejectionModal: false,
    });
  };

  handleReject = (remark) => {
    this.props?.child.current.mapData("reject", remark);
    this.setState({
      openRejectionModal: false,
    });
  };

  render() {
    return (
      <div>
        {this.props?.coorData && this.props?.coorData?.length ? (
          <Box
            sx={{
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingTop: "3px",
            }}
          >
            <Grid container spacing={2}>
              {this?.props?.hideScreen ? (
                <Grid xs={this?.props?.leftgrid} item>
                  <ImageViewer isFullView={this?.props?.isFullView} />
                </Grid>
              ) : (
                <></>
              )}
              <Grid xs={this?.props?.rightgrid} item>
                {this.props?.is_template_uploaded === true ? (
                  <MapDataTable
                    selectedFile={this.state?.selectedFile}
                    parametersData={this.props?.parametersData}
                    ref={this.props?.child}
                    role={localStorage?.userRole}
                    reProcess={this.props.reProcess}
                    isDataRejectedByValidator={
                      this?.props?.isDataRejectedByValidator
                    }
                    isFullView={this?.props?.isFullView}
                    reProcessEntireBatch={this?.props?.reProcessEntireBatch}
                    entireBatchRejectedByVali={
                      this?.props?.entireBatchRejectedByVali
                    }
                  />
                ) : this.props?.is_template_uploaded === false ? (
                  <CNCTableWrapper
                    selectedFile={this.state?.selectedFile}
                    ref={this.props?.child}
                    role={localStorage.userRole}
                    parametersData={this.props?.parametersData}
                    columnsCount={this.props?.columnsCount}
                    reProcess={this.props?.reProcess}
                    isDataRejectedByValidator={
                      this?.props?.isDataRejectedByValidator
                    }
                    showContextMenu={true}
                    isDisableOnChangeInput={false}
                    isDisableOnBlur={false}
                    isFullView={this?.props?.isFullView}
                    reProcessEntireBatch={this?.props?.reProcessEntireBatch}
                    entireBatchRejectedByVali={
                      this?.props?.entireBatchRejectedByVali
                    }
                  />
                ) : (
                  <TableSkeleton />
                )}
              </Grid>
            </Grid>
          </Box>
        ) : (
          <ProgressBar />
        )}

        {this.state.openRejectionModal && (
          <ModalProcessor
            modalOpen={this.state.openRejectionModal}
            handleClose={this.handleCloseModal}
            handleReject={this.handleReject}
            isShowClearButton={false}
            disableDeleteRejection={true}
            isShowDeleteButton={false}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.pro?.coorData?.coordinatesDetails || [],
    parametersData: state.pro?.coorData?.mapping_details?.parametersData || [],
    is_template_uploaded: state.pro?.coorData?.is_template_uploaded,
    apiStatus: state.pro?.apiStatus,
    columnsCount: state.pro?.coorData?.mapping_details?.columnsCount,
    reProcess: state.pro?.coorData?.mapping_details?.reProcess,
    isDataRejectedByValidator:
      state.pro?.coorData?.mapping_details?.isDataRejectedByValidator,
    validatorRowRejectionData:
      state.pro?.coorData?.mapping_details?.validatorRowRejectionData,
    proRowRejectionData:
      state.pro?.coorData?.mapping_details?.proRowRejectionData,
    reProcessEntireBatch:
      state.pro?.coorData?.mapping_details?.reProcessEntireBatch,
    entireBatchRejectedByVali:
      state?.pro?.coorData?.mapping_details?.entireBatchRejectedByVali,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataEntryConatainer);
